var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"app-running-line"},[_c('p',{ref:"lineRef",class:['app-running-line__text', { 'static': !_vm.isRunning }]},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }